import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { replaceAll } from '../../../global/helpers/string-helpers';
import { TcsmStates } from '../../../root/tcsm-model';
import { MapContext } from '../models';

export const domoUrl = 'https://domo.cpg.org';

export function createFilters(selectedProv: string, selectedDio: string, mapContext: MapContext) {
	let filterParams = [];

	const selectedMap = mapContext === MapContext.INTERNATIONAL ? 'Y' : 'N';
	if (selectedProv && selectedMap === 'N') {
		filterParams.push({
			column: 'emp_nondomestic_dio_1',
			operator: 'IN',
			values: [selectedMap],
		});
		filterParams.push({
			column: 'emp_province_1',
			operator: 'IN',
			values: [selectedProv],
		});
		const dioName = selectedDio || 'ALL';
		filterParams.push({ column: 'emp_diocese_1', operator: 'IN', values: [dioName] });
	} else if (selectedDio && selectedMap === 'Y') {
		filterParams.push({
			column: 'emp_nondomestic_dio_1',
			operator: 'IN',
			values: [selectedMap],
		});
		filterParams.push({
			column: 'emp_province_1',
			operator: 'IN',
			values: ['2', '8', '9'],
		});

		filterParams.push({ column: 'emp_diocese_1', operator: 'IN', values: [selectedDio] });
	}

	const defaultFilters = [
		{ column: 'emp_province_1', operator: 'IN', values: ['ALL'] },
		{ column: 'emp_diocese_1', operator: 'IN', values: ['ALL'] },
		{ column: 'emp_nondomestic_dio_1', operator: 'IN', values: [selectedMap] },
	];
	filterParams = filterParams.length > 0 ? filterParams : defaultFilters;
	return filterParams;
}

export function getPortFilters(portId, filters) {
	if (portId === 'IRqxLpp' || portId === 'IRrkVqp') {
		return filters.filter(f => f.column !== 'emp_diocese_1');
	}
	return filters;
}

export function sendFilterMessage(port, filters) {
	if (port) {
		const portFilters = getPortFilters(port.id, filters);
		try {
			const result = port.obj.postMessage({
				id: 'setFilters1',
				jsonrpc: '2.0',
				method: '/v1/filters/apply',
				params: {
					filters: portFilters,
				},
			});
			return result;
		} catch (e) {
			return true;
		}
	}
	return true;
}


export function EmbedAction() {

	const filter = useSelector<TcsmStates, any>(state => state?.clergyCompReportState.filter);
	const mapContext = useSelector<TcsmStates, MapContext>(state => state?.clergyCompReportState.mapContext);
	const ports = useSelector<TcsmStates, any[]>(state => state?.clergyCompReportState.ports);


	useEffect(() => {
		const payload = createFilters(filter?.region?.replace('p', ''), replaceAll(replaceAll(filter?.dio, 'Dio_', ''), '_', ' '), mapContext);
		Object.keys(ports).map((id) => sendFilterMessage({ id, obj: ports[id] }, payload));
	}, [filter, mapContext, ports]);

	return (
		<></>
	);
}